// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footerContainer":"Footer_footerContainer__CulEb","footerSection":"Footer_footerSection__Km-0V","copyright":"Footer_copyright__ji7jm"};